import angular from 'angular';

import {
    openPanel,
    closePanel,
} from './job-apply-center.actions.js';

/**
 * @ngdoc service
 * @name JobApplyCenterPanelService
 * @module portfolium.component.JobApplyCenter
 **/
export class JobApplyCenterPanelService {
    constructor(
        $mdPanel,
        $ngRedux,
        $mdDialog,
        $mdMedia
    ) {
        this.$mdPanel = $mdPanel;
        this.$ngRedux = $ngRedux;
        this.$mdDialog = $mdDialog;
        this.$mdMedia = $mdMedia;
    }

    /**
     * Create a new panel instance
     * @param {Object} panelConfig.job Job to be applied to
     * @param {Function} panelConfig.onJobApplied Sets jobApplied to true
     * @return {MdPanelRef}
     */
    _createPanel(panelConfig) {
        const isMobile = !this.$mdMedia('gt-xs');
        const width = 512;
        const windowHeight = angular.element(window).height();
        const animationPosition = {
            top: (isMobile) ? windowHeight : 0,
            left: (isMobile) ? 0 : -width,
        };
        const position = this.$mdPanel.newPanelPosition()
            .absolute()
            .top(0)
            .left(0);
        const animation = this.$mdPanel.newPanelAnimation()
            .openFrom(animationPosition)
            .closeTo(animationPosition)
            .withAnimation(this.$mdPanel.animation.SLIDE);
        const config = {
            controller: angular.noop,
            controllerAs: '$ctrl',
            template: `
                <pf-job-apply-center
                     job="$ctrl.job"
                     md-panel-ref="$ctrl.mdPanelRef"
                     on-job-applied="$ctrl.onJobApplied()">
                </pf-job-apply-center>
            `,
            locals: {
                job: panelConfig.job,
                onJobApplied: panelConfig.onJobApplied,
            },
            panelClass: 'pf-panel pf-sidenav-panel',
            attachTo: angular.element(document.body),
            position: position,
            animation: animation,
            hasBackdrop: true,
            trapFocus: true,
            clickOutsideToClose: true,
            escapeToClose: true,
            focusOnOpen: true,
            zIndex: 70,
            onDomRemoved: () => {
                // Update application state
                this.$ngRedux.dispatch(closePanel());

                // Reset panel
                this.panel = undefined;

                // Make sure the panel is destroyed when closed
                panel.destroy();
            },
        };
        const panel = this.$mdPanel.create(config);

        return panel;
    }

    /**
     * Open the panel
     * @param {Object} panelConfig.job Job to be applied to
     * @param {Function} panelConfig.onJobApplied Sets jobApplied to true
     * @return {Promise<MdPanelRef>}
     */
    open(panelConfig) {
        // If panel is already open, close and destroy it, intended for mobile mode use
        if (this.panel) {
            return this.panel.close().then(()=>{
                return this.panel = undefined;
            });
        }

        // Initialize state
        this.$ngRedux.dispatch(openPanel());

        // Set panel reference
        this.panel = this._createPanel(panelConfig);

        // Hide any dialogs if they are open
        return this.$mdDialog.hide().then(() => {
            // Open the panel
            return this.panel.open();
        });

    }
}

JobApplyCenterPanelService.$inject = ['$mdPanel', '$ngRedux', '$mdDialog', '$mdMedia'];
